import { createContext, useState, useEffect } from 'react';
import { variables } from '../Variables/Variable';

export const MetadataContext = createContext();

export const MetadataProvider = ({ children }) => {
  const [metadata, setMetadata] = useState({});
  const [dynamicMeta, setDynamicMeta] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getMetaData();
  }, []);

  const getMetaData = async () => {
    const URL = variables.API_URL + "MetaData/GetMetaDatas";
    const response = await fetch(URL);
    const listItems = await response.json();
    setMetadata(listItems);
    setLoading(false);
  };

  return (
    <MetadataContext.Provider
      value={{
        metadata,
        dynamicMeta,
        setDynamicMeta,
        loading
      }}
    >
      {children}
    </MetadataContext.Provider>
  );
};
